import React from "react";
import Context from "../../../Context";
import FamDocModal from "./FamDocModal";

const listLimit = 300;

export default class FamManual extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      pending: false,

      modalMode: this.props.defaultMode || "fam",

      listAll: [],
      listFam: [],
      listUnfam: [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.docId !== this.props.docId) {
      this.load();
    }
    if (prevProps.defaultMode !== this.props.defaultMode) {
      this.setState({ modalMode: this.props.defaultMode });
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let listAll = await this.context.api.qa("/familiarized/manual/list", {
      id: this.props.docId,
      reclimit: listLimit,
      orderby: ["staffname ASC"],
    });
    let listFam = listAll.filter((item) => item.familiarized);
    let listUnfam = listAll.filter((item) => !item.familiarized);
    this.setState({ listAll, listFam, listUnfam, pending: false });
  };

  onModalShow = (mode) => {
    this.setState({ showModal: true, modalMode: mode });
  };

  onModalClose = () => {
    this.setState({ showModal: false });
  };

  onSwitchMode = () => {
    this.setState((state) => {
      return { modalMode: state.modalMode === "fam" ? "unfam" : "fam" };
    });
  };

  render() {
    const { listAll, listFam, listUnfam, pending } = this.state;
    if (pending) {
      return (
        <>
          <div className={this.props.className}>
            <div className="spinner-border spinner-border-sm text-muted"></div>
          </div>
        </>
      );
    }

    if (listAll.length > 0) {
      return (
        <>
          <FamDocModal
            show={this.state.showModal}
            onClose={this.onModalClose}
            list={this.state.modalMode === "fam" ? listFam : listUnfam}
            onClick={this.props.onClick}
            mode={this.state.modalMode}
            onSwitchMode={this.onSwitchMode}
            view="staff"
          />
          <div className={this.props.className}>
            <button
              title="Лист ознакомления"
              onClick={() => this.onModalShow(this.state.modalMode)}
              className="btn btn-icon btn-white"
            >
              <i className="fa fa-id-badge"></i>
            </button>
          </div>
        </>
      );
    }
    return <></>;
  }
}
